import { z } from 'zod'

import { propertyTypeSchema, selectOptionSchema as propertySelectOptionSchema } from '../model/modelProperty.ts'
//
// enum
//
export const fieldTypeSchema = propertyTypeSchema
export type FieldType = z.infer<typeof fieldTypeSchema>

//
// parts
//
export const nodePathSchema = z.array(z.string())
export type NodePath = z.infer<typeof nodePathSchema>

export const selectOptionSchema = propertySelectOptionSchema
export type SelectOption = z.infer<typeof selectOptionSchema>

export const propertyNameWithStreamNameSchema = z.object({
  streamName: z.string(),
  propertyName: z.string(),
})

export { propertyMetaSchema as fieldMetaSchema } from '../model/modelProperty.ts'
